module.exports = __webpack_public_path__ + "static/media/check-square.9df03195.svg";